var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDimg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5093be27a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.875 105.628906 L 283.453125 105.628906 L 283.453125 269.695312 L 91.875 269.695312 Z M 91.875 105.628906 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "997798b584"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 283.054688 156.699219 L 278 202.703125 L 278.320312 205.320312 L 162.164062 219.5 L 148.890625 236.308594 C 148.5625 236.722656 148.679688 237.128906 148.78125 237.332031 C 148.878906 237.539062 149.125 237.882812 149.652344 237.882812 L 270.773438 237.882812 L 270.773438 243.164062 L 260.648438 243.164062 L 257.324219 251.710938 C 259.402344 253.5625 260.714844 256.253906 260.714844 259.253906 C 260.714844 264.84375 256.1875 269.371094 250.597656 269.371094 C 245.011719 269.371094 240.484375 264.84375 240.484375 259.253906 C 240.484375 256.078125 241.949219 253.25 244.238281 251.394531 L 241.84375 243.164062 L 175.183594 243.164062 L 171.863281 251.710938 C 173.9375 253.5625 175.253906 256.253906 175.253906 259.253906 C 175.253906 264.84375 170.726562 269.371094 165.136719 269.371094 C 159.550781 269.371094 155.019531 264.84375 155.019531 259.253906 C 155.019531 256.078125 156.488281 253.25 158.777344 251.394531 L 156.382812 243.164062 L 149.652344 243.164062 C 147.238281 243.164062 145.082031 241.8125 144.027344 239.636719 C 142.972656 237.460938 143.25 234.933594 144.746094 233.035156 L 156.046875 218.722656 L 114.023438 121.492188 L 108.730469 118.960938 L 107.773438 121.074219 L 94.8125 115.191406 C 92.296875 114.046875 91.179688 111.082031 92.324219 108.566406 C 93.464844 106.046875 96.433594 104.933594 98.949219 106.078125 L 111.910156 111.960938 L 110.914062 114.152344 L 118.085938 117.582031 L 125.414062 134.53125 L 272.238281 143.832031 C 278.851562 144.253906 283.777344 150.113281 283.054688 156.699219 Z M 283.054688 156.699219 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "14f36ad796"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#5093be27a2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#997798b584)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 91.875 105.628906 L 283.125 105.628906 L 283.125 269.371094 L 91.875 269.371094 Z M 91.875 105.628906 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimg1);
export default __webpack_public_path__ + "static/media/dimg1.b19b5f431780412978f00e534841cfb8.svg";
export { ForwardRef as ReactComponent };